import {
  ContentContainer,
  Title,
  TitleContainer,
  Column,
  StyledButton,
  ButtonDiv,
  Textarea,
  TitlePrompt,
} from "./CustomPromptModal.styles";

import { ReactComponent as Close } from "../../assets/icons/close.svg";
import { useTranslation } from "react-i18next";

import { ReactComponent as Loader } from "../../assets/icons/loaderWhite.svg";

import Modal2 from "../Modal/Modal2";

const CustomPromptModal = ({
  open,
  close,
  onClickAccept,
  realLifePrompt,
  setRealLifePrompt,
  packagingPrompt,
  setPackagingPrompt,
  backgroundPrompt,
  setBackgroundPrompt,
  loading,
}) => {
  const { t } = useTranslation();

  return (
    <Modal2
      border={"2px solid #484888"}
      bg={"linear-gradient(360deg, #7f7fac -100%, #484888 100%)"}
      onClose={close}
      open={open}
      height={"fit-content"}
      width={"fit-content"}
      borderRadius={20}
    >
      <ContentContainer>
        <Column>
          <TitleContainer style={{ flexDirection: "row", gap: 20 }}>
            <Title>{t("custom-prompt-for-your-image")}</Title>
            <Close
              className="close"
              fill="#fff"
              onClick={!loading ? () => close() : () => {}}
            />
          </TitleContainer>
          <TitlePrompt>{t("real-life-image-prompt")}</TitlePrompt>
          <Textarea
            placeholder=""
            value={realLifePrompt}
            onChange={(e) => setRealLifePrompt(e.target.value)}
          />
          <TitlePrompt>{t("packaging-details-prompt")}</TitlePrompt>

          <Textarea
            placeholder=""
            value={packagingPrompt}
            onChange={(e) => setPackagingPrompt(e.target.value)}
          />
          <TitlePrompt>{t("background-prompt")}</TitlePrompt>

          <Textarea
            placeholder=""
            value={backgroundPrompt}
            onChange={(e) => setBackgroundPrompt(e.target.value)}
          />
          <ButtonDiv>
            <StyledButton onClick={close}>
              {!loading ? t("confirm") : <Loader height={24} width={24} />}
            </StyledButton>
          </ButtonDiv>
        </Column>
      </ContentContainer>
    </Modal2>
  );
};

export default CustomPromptModal;
